import React from 'react';
import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import 'components/commonMultiForm/CommonMultiForm.scss';

const BillingFilter = ({
  formData,
  billingFilterValue,
  handleFilter,
  onHandleAutoSuggestion,
}) => {
  // ---When values are selected---
  const handleChange = (name, newValue) => {
    handleFilter(name, newValue);
  };

  return (
    <Box className="customAutocomplete billingFilterAutocomplete">
      <Typography variant={'body2'} className="fw600 pb10" component={'p'}>
        {formData?.label}
        {formData?.label &&<span className="colorRed">*</span>}
      </Typography>
      <Autocomplete
        value={
          billingFilterValue?.[formData?.name]?.value?.length > 0
            ? billingFilterValue?.[formData?.name]
            : ''
        }
        defaultValue={formData?.defaultValues?.value && formData?.defaultValues}
        name={formData?.name}
        autoComplete={false}
        onChange={(event, value) => {
          handleChange(formData?.name, value);
        }}
        id="controllable-states-demo"
        options={formData?.options || []}
        popupIcon={<ExpandMoreRoundedIcon />}
        onInputChange={(event, value) =>
          onHandleAutoSuggestion(event, value, formData?.name)
        }
        renderInput={(params) => (
          <TextField {...params} placeholder={formData?.placeholder} />
        )}
      />
    </Box>
  );
};

export default BillingFilter;
